import Panel from "../Panel";

export function Wrapper(props) {
  return <Panel>{props.children}</Panel>;
}

export default Wrapper;
